import React from 'react';
import Layout from '../components/layout';
import CoverImage from '../components/CoverImage/CoverImage'
import Category from '../components/Category/Category'
import Breadcrumb from '../components/Breadcrumb/Breadcrumb'
import {graphql, Link} from 'gatsby'


function thumbnail(image) {
    let featured_image;
    if (!image) {
        
        featured_image = 'https://images.pexels.com/photos/47730/the-ball-stadion-football-the-pitch-47730.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260';
    } else {
        featured_image = image.source_url;
    }
    //console.log(image)
    return featured_image;
}

const archiveTemplate = ({
    
    data,
    pageContext: {
        catId,
        edgeNode,
        
    },
}) => {
    
    
    
    
    return (
    <Layout>
        <CoverImage text={`Kategori: ${edgeNode.name}`} image="https://images.pexels.com/photos/47730/the-ball-stadion-football-the-pitch-47730.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260" />
        
        
        <div className="bg-light">
        <Breadcrumb title={edgeNode.name} archive="Kategorier" archiveLink={`/kategori/a-laget`} />
            <div className="container py-2">
                <div className="row">
                    <div className="col-md-9 mx-auto">
                    <h4 className="font-weight-bold">Innlegg</h4>
                        <div className="row">
                            {data.allWordpressPost.edges.map(post => (
                            <>
                                
                                
                            <div className="col-lg-6 col-xl4" key={post.node.id}>
                                <div className="card my-2">
                                    <img src={thumbnail(post.node.featured_media)} alt={post.node.title} className="img-fluid" />
                                    <div className="card-body">
                                        <h2>{post.node.title}</h2>
                                        <div dangerouslySetInnerHTML={{__html: post.node.excerpt}}></div>
                                        <Link to={`/innlegg/${post.node.slug}`} >Les mer</Link>
                                    </div>
                                </div>
                            </div>
                            </>
                            ))}
                        </div>
                    </div>
                    <div className="col-md-3">
                        <Category />
                    </div>
                </div>
            </div>
        </div>
    </Layout>

)};

export default archiveTemplate;

export const pageQuery = graphql`

query ($catId: Int!) {
        allWordpressPost( 
            filter: { categories: { elemMatch: { wordpress_id: { eq: $catId } } } } 
        ) {
            edges {
                node {
                    id
                    title
                    categories {
                        name
                        wordpress_id
                    }
                    excerpt
                    slug
                    fimg_url {
                      source_url
                    }
                    featured_media {
                        source_url
                      }
                    
                }
            }
        }
    }
`;